export default "__VITE_ASSET__y_$F9fsP__"